module.exports = __webpack_public_path__ + "static/img/visible_veins-01.6e7f77b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/visible_veins-01.jpg
// module id = 299
// module chunks = 1